import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 60px);
  color: #647E93;
  padding: 12px 20px;
`;

export const SelectContainer = styled.div`
  width: 100%;
  margin: 20px 0;

  label { 
    font-size: 1rem;
  }

  select { 
    margin: 8px 0 16px 0;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  font-size: 1rem;

  div {
    margin: 20px 40px;

    &:first-child {
      margin-left: 0;
    }
  }
`;
